import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import {
  ScopeOption, Radio, ScopeDetail, ScopeCount
} from './MachineCsv.styled';

function ScopeChoice({
  scope, selected, label, detail, count, onSelect
}) {
  const handleClick = useCallback(() => onSelect(scope), [onSelect, scope]);
  return (
    <ScopeOption type="button" role="radio" aria-checked={selected} selected={selected} onClick={handleClick}>
      <Radio selected={selected} />
      <b>{label}</b>
      {detail && <ScopeDetail>{detail}</ScopeDetail>}
      {count !== null && <ScopeCount>{count}</ScopeCount>}
    </ScopeOption>
  );
}

ScopeChoice.propTypes = {
  scope: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  detail: PropTypes.string,
  count: PropTypes.string,
  onSelect: PropTypes.func.isRequired
};

ScopeChoice.defaultProps = {
  detail: null,
  count: null
};

export default ScopeChoice;
